import MainHeader from "./MainHeader";
import { useEffect, useState } from "react";
import MainSlider from "./MainSlider";
import styles from "../Styles/dashboardContainer.module.css";
import { ComponentsNames } from "../Utils/Constants";
import { Outlet, useNavigate } from "react-router-dom";
import { localUrlEnum } from "../Utils/UrlEnum";
import { isMobile, shouldShowMobileMenu } from "../Utils/Utils";
import withRole from "../Hooks/withRole";

function DashboardContainer(props: any) {
  const navigate = useNavigate();
  const [hideSlider, setHideSlider]: any = useState(false);

  /**
   * Lock body scroll when mobile menu is open
   */
  useEffect(() => {
    if (hideSlider) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [hideSlider]);

  /**
   * Close menu when window is resized above 1590px
   */
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1590 && hideSlider) {
        setHideSlider(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [hideSlider]);

  /**
   *
   */
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      navigate(localUrlEnum.login);
    }
  }, []);

  /**
   *
   */
  const handleToggleSlider = () => {
    setHideSlider(!hideSlider);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainHeader}>
        <MainHeader
          name={ComponentsNames?.MainHeader}
          shouldRenderSearchBar={props.shouldRenderSearchBar}
          setHideSlider={handleToggleSlider}
        />
      </div>
      {isMobile() || shouldShowMobileMenu() ? (
        <div className={styles.secondContainer}>
          <div
            className={hideSlider ? styles.overlay : styles.overlayHide}
            onClick={handleToggleSlider}
          >
            <div
              className={hideSlider ? styles.mainSlider : styles.mainSliderHide}
              onClick={(e) => e.stopPropagation()}
            >
              <MainSlider
                name={ComponentsNames.MainSlider}
                data={props.data}
                setHideSlider={handleToggleSlider}
              />
            </div>
          </div>
          <Outlet />
        </div>
      ) : (
        <Outlet />
      )}
    </div>
  );
}

export default withRole(DashboardContainer);
